import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Cookie from 'js-cookie'

import "./assets/iconfont/iconfont.css"

import VueAwesomeSwiper from 'vue-awesome-swiper' // swiper
import './assets/css/swiper-bundle.css'
Vue.use(VueAwesomeSwiper)

import VueAnimateNumber from 'vue-animate-number'  // 数字加载
Vue.use(VueAnimateNumber)



Vue.config.productionTip = false
Vue.prototype.Cookies = Cookie;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
